<template>
  <Modal2 :modalId="modalId" ref="modal2">
    <div class="mdl-body-s">
      <h2>
        <img
          src="@/assets/icons/ico_info.png"
          alt="情報アイコン"
          class="ico-bace ico-s"
        />新しい通信デバイス登録が含まれています。
      </h2>
      <p>
        監視デバイスは、登録された日を基点としてサービス利用料が発生します。<br />
        請求サイクルや支払い方法の変更については、サービスアカウント設定をご確認ください。
      </p>
    </div>

    <div class="modal-footer btn-area" >
      <Button class="btn btn-cancel" data-bs-dismiss="modal">
        キャンセル
      </Button>
      <Button @click="confirmAction">登録する</Button>
    </div>

  </Modal2>
</template>

<script>
import { Button, Modal2 } from "components";

export default {
  name: "CreateConfirmModal",
  props: {
    modalId: {
      type: String,
      default: "",
    },
  },
  components: {
    Button,
    Modal2,
  },
  data() {
    return {
      icons: {
      },
    };
  },
  methods: {
    async openModal() {
      this.$refs.modal2.openModal();
    },
    async confirmAction() {
      this.$emit("confirm");
      this.$refs.modal2.closeModal();
    },
  },
};
</script>
